export function formatDateTime(dateTime) {
    if (dateTime === undefined) {
        return '';
    }
    return new Date(dateTime).toLocaleString();
}